module.exports = __webpack_public_path__ + "static/img/avatar-male.576d3c8d.png";